var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-modal',{ref:"dataModal",attrs:{"size":"xl","fetch-data":_vm.fetch,"title":_vm.titleFormatted,"fields":_vm.fields,"additional-parameters":_vm.additionalParameters,"sort-order":_vm.sortOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }